module.exports = __webpack_public_path__ + "media/images/emblems/Echandens-coat_of_arms-c99ded6a50c6b05c3ceaa9aa6d7f9286.svg";